module.exports = __webpack_public_path__ + "img/img-123.442f5021.png";